export const PowerLinesDescription = () => (
  <div className="flex flex-col gap-y-4">
    <div>
      <div className="font-semibold">Network line data</div>
      <div>The network data is divided into overhead lines and underground cables.</div>
    </div>

    <div>
      <div className="font-semibold">Tower data</div>
      <div>
        Towers, pylons, and poles for carrying overhead power lines are represented by points indicating the location of
        the feature and are not presented with a voltage class.
      </div>
    </div>

    <div>
      <div className="font-semibold">Note on data usage</div>
      <div>
        This data is drawn from records made publicly available by Distribution Network Operators (DNOs), National Grid
        and other data sources, and no guarantees are given regarding the completeness of the data. This data is
        indicative and <b>should not</b> be relied on for planning intrusive works at a site.
      </div>
    </div>
  </div>
);
